import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import PhoneInput from 'components/PhoneInput';
import _ from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { preparePhone, prepareName, prepareCompany } from 'utils/services';
import Select from 'components/Select';
import Loader from 'components/Loader';

import Logo from 'shared/img/logo_big.png';
import { COMPANY_TYPE, COMPANY_LEGAL, COMPANY_CATEGORY, COMPANY_IMPORTANT } from '../../constants';

import { ReactComponent as SuccessIcon } from 'shared/img/success.svg';

class NewClientInfo extends Component {
  state = {
    clickHandleSend: false,
    formData: {
      name: "",
      phone: "",
      company: "",
      companyType: [],
      companyLegal: [],
      companyCategory: [],
      companyImportant: [],
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.registerFormSended && this.props.registerFormSended) {
      window.location = '#success';
    }

    if (!prevProps.registerFormSended && this.props.registerFormSendedError && this.state.clickHandleSend) {
      this.setState({
        clickHandleSend: false
      });
    }
  }

  handleUserInput = e => {
    const targetName = e.target.name;

    if (targetName === 'name'){
      e.target.value = prepareName(e.target.value);
    }

    if (targetName === 'company'){
      e.target.value = prepareCompany(e.target.value);
    }

    if (targetName === 'phone'){
      e.target.value = e.target.value;
    }

    this.setState({
      formData: {
        ...this.state.formData,
        ...{[targetName]: e.target.value}
      }
    });
  }

  handlePhone = value => {
    this.setState({
      formData: {
        ...this.state.formData,
        phone: value
      }
    });
  }

  handleCompany = () => {
    window.location = '#company';
  }

  isNotValidName(name) {
    if (_.isEmpty(name)) {
      return true;
    }

    return false;
  }

  isNotValidCompany(company) {
    if (_.isEmpty(company)) {
      return true;
    }

    return false;
  }

  isNotValidSelect(options) {
    if (_.isEmpty(options)) {
      return true;
    }

    return false;
  }

  isNotValidPhone(phone) {
    if (_.isEmpty(phone)) {
      return true;
    }

    return phone.length !== 13 && phone.length !== 12;
  }

  hasPersonInfo = () => {
    const { name, phone } = this.state.formData;

    if (!this.isNotValidName(name) && !this.isNotValidPhone(phone)) {
      return true;
    }

    return false;
  }

  hasCompanyInfo = () => {
    const { company, companyType, companyCategory, companyLegal, companyImportant } = this.state.formData;

    if (
      this.hasPersonInfo() &&
      !this.isNotValidCompany(company) &&
      !this.isNotValidSelect(companyType) &&
      !this.isNotValidSelect(companyCategory) &&
      !this.isNotValidSelect(companyLegal) &&
      !this.isNotValidSelect(companyImportant)
    ) {
      return true;
    }

    return false;
  }

  handleCompanySelect = (formValue, selected) => {
    this.setState({
      formData: {
        ...this.state.formData,
        ...{ [formValue]: selected }
      }
    });
  }

  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.handleSend();
    }
  }

  handleSend = () => {
    const { setNotification, registerForm } = this.props;
    const { formData } = this.state;

    if (this.hasPersonInfo()){
      this.setState({
        clickHandleSend: true
      });

      registerForm(formData);
    }else{
      setNotification('error');
    }
  }

  render() {
    const { style, location, currentLocale, intl } = this.props;
    const { formData, clickHandleSend } = this.state;

    const showCompanyPage = location.hash === '#company' && this.hasPersonInfo();

    return (
      <div className={classNames(style.root, {[style.rootScrolled]: showCompanyPage })}>
        <Link className={style.logoBtn} to='/' onClick={this.handleLogo}>
          <img src={Logo} alt='Sparta лого' className={style.logoImg} />
        </Link>
        {
          location.hash === '#person'
          ? <>
              <div className={style.form}>
                <label className={style.formControl}>
                  <span className={style.label}><FormattedMessage id="Login.PROFILE_NAME" /></span>
                  <input className={style.input} value={formData.name} name='name' onChange={this.handleUserInput} />
                </label>
                <label className={style.formControl}>
                  <span className={style.label}><FormattedMessage id="Login.PROFILE_PHONE" /></span>
                  <div className={style.telWrapp}>
                    <PhoneInput setPhone={this.handlePhone} />
                  </div>
                </label>
                <button className={style.btnCompany} onClick={this.handleCompany} disabled={!this.hasPersonInfo()}>
                  <FormattedMessage id="Login.COMPANY_BTN" />
                </button>
              </div>
            </>
          : location.hash === '#success'
          ? <>
              <div className={classNames(style.html, style.row)}>
                <div className={style.col}>
                  <SuccessIcon />
                </div>
                <div className={style.col}>
                  <h3><FormattedMessage id="Login.SEND_SUCCESS_HEADING" /></h3>
                  <p><FormattedMessage id="Login.SEND_SUCCESS_TEXT" values={{ br: <br/>, link: <a className={style.link} href='https://color-it.ua/'>color-it.ua</a> }} /></p>
                  <a className={style.btnColor} href='https://color-it.ua/' target='_blank'><FormattedMessage id="Login.COLORIT_BTN" /></a>
                </div>
              </div>
            </>
          : showCompanyPage
          ? <>
              <div className={style.html}>
                <p><FormattedMessage id="Login.COMPANY_TEXT" values={{ br: <br/> }} /></p>
              </div>
              <div className={style.form}>
                <label className={style.formControl}>
                  <span className={style.label}><FormattedMessage id="Login.COMPANY_NAME" /></span>
                  <input className={style.input} value={formData.company} name='company' onChange={this.handleUserInput} />
                </label>
                <label className={style.formControl}>
                  <span className={style.label}><FormattedMessage id="Login.COMPANY_TYPE" /></span>
                  <Select 
                    options={COMPANY_TYPE[currentLocale]}
                    selected={formData.companyType}
                    placeholder={intl.formatMessage({id: 'App.SELECT'})}
                    noOptionsMessage=''
                    onChange={this.handleCompanySelect.bind(this, 'companyType')}
                    isSearchable={false}
                    className='selectLogin'
                    classNamePrefix='selectLogin'
                    isMulti={true}
                    name='company_type'
                  />
                </label>
                <label className={style.formControl}>
                  <span className={style.label}><FormattedMessage id="Login.COMPANY_LEGAL" /></span>
                  <Select 
                    options={COMPANY_LEGAL[currentLocale]}
                    selected={formData.companyLegal}
                    placeholder={intl.formatMessage({id: 'App.SELECT'})}
                    noOptionsMessage=''
                    onChange={this.handleCompanySelect.bind(this, 'companyLegal')}
                    isSearchable={false}
                    className='selectLogin'
                    classNamePrefix='selectLogin'
                    isMulti={true}
                    name='company_legal'
                  />
                </label>
                <label className={style.formControl}>
                  <span className={style.label}><FormattedMessage id="Login.COMPANY_CATEGORY" /></span>
                  <Select 
                    options={COMPANY_CATEGORY[currentLocale]}
                    selected={formData.companyLegal}
                    placeholder={intl.formatMessage({id: 'App.SELECT'})}
                    noOptionsMessage=''
                    onChange={this.handleCompanySelect.bind(this, 'companyCategory')}
                    isSearchable={false}
                    className='selectLogin'
                    classNamePrefix='selectLogin'
                    isMulti={true}
                    name='company_category'
                  />
                </label>
                <label className={style.formControl}>
                  <span className={style.label}><FormattedMessage id="Login.COMPANY_IMPORTANT" /></span>
                  <Select 
                    options={COMPANY_IMPORTANT[currentLocale]}
                    selected={formData.companyLegal}
                    placeholder={intl.formatMessage({id: 'App.SELECT'})}
                    noOptionsMessage=''
                    onChange={this.handleCompanySelect.bind(this, 'companyImportant')}
                    isSearchable={false}
                    className='selectLogin'
                    classNamePrefix='selectLogin'
                    isMulti={true}
                    name='company_important'
                  />
                </label>
                {clickHandleSend 
                  ? <div className={style.loader}>
                      <Loader />
                    </div>
                  : <button className={style.btnCompany} onClick={this.handleSend} disabled={!this.hasCompanyInfo()}>
                      <FormattedMessage id="Login.SEND_BTN" />
                    </button>
                }
              </div>
            </>
          : <>
              <div className={style.html}>
                <p><FormattedMessage id="Login.NEW_CLIENT_TEXT" values={{ br: <br/> }} /></p>
              </div>
              <Link className={style.btn} to='/new-client-info#person'><FormattedMessage id="Login.REGISTER_BTN" /></Link>
            </>
        }
      </div>
    )
  }
}

NewClientInfo.defaultProps = {
  style: require('./NewClientInfo.module.scss')
};

NewClientInfo.propTypes = {
  currentLocale: PropTypes.string.isRequired,
  setNotification: PropTypes.func.isRequired,
  registerForm: PropTypes.func.isRequired,
  registerFormSended: PropTypes.bool.isRequired,
  intl: PropTypes.object.isRequired,
};

export default NewClientInfo;